(() => {
  const configScript = document.querySelector('script[data-surprise-gift]');
  if (!configScript || (window.Shopify && Shopify.designMode)) return;

  let knownCartItemCount = Math.max(
    0,
    Number(configScript.dataset.initialCartCount || 0)
  );

  function renderGiftNotice() {
    const notice = document.getElementById('CartDrawer-SurpriseGiftNotice');
    if (!notice) return;

    const hasItems = knownCartItemCount > 0;
    const earned = knownCartItemCount >= 2;
    const promptText = notice.dataset.promptText;
    const earnedText = notice.dataset.earnedText;

    notice.hidden = !hasItems;
    notice.classList.toggle('is-prompt', hasItems && !earned);
    notice.classList.toggle('is-earned', hasItems && earned);
    notice.textContent = earned ? earnedText : promptText;
  }

  function bindCartUpdates(attempt) {
    if (
      typeof subscribe === 'function' &&
      window.PUB_SUB_EVENTS &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event || event.source === 'surprise-gift') return;

        const cartData = event.cartData;
        const hasCompleteCart =
          cartData &&
          Array.isArray(cartData.items) &&
          Number.isFinite(Number(cartData.item_count));

        if (hasCompleteCart) {
          knownCartItemCount = Math.max(0, Number(cartData.item_count) || 0);
        } else if (event.source === 'product-form') {
          knownCartItemCount += Math.max(
            1,
            Number(cartData && cartData.quantity) || 1
          );
        }

        renderGiftNotice();
      });
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => bindCartUpdates(attempt + 1), 100);
    }
  }

  function boot() {
    renderGiftNotice();
    bindCartUpdates(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();